var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12.0004 2.3999C6.69879 2.3999 2.40039 6.6983 2.40039 11.9999C2.40039 17.3015 6.69879 21.5999 12.0004 21.5999C17.302 21.5999 21.6004 17.3015 21.6004 11.9999C21.6004 6.6983 17.302 2.3999 12.0004 2.3999ZM16.8004 12.7999H12.8004V16.7999C12.8004 17.2423 12.442 17.5999 12.0004 17.5999C11.5588 17.5999 11.2004 17.2423 11.2004 16.7999V12.7999H7.20039C6.75879 12.7999 6.40039 12.4423 6.40039 11.9999C6.40039 11.5575 6.75879 11.1999 7.20039 11.1999H11.2004V7.1999C11.2004 6.7575 11.5588 6.3999 12.0004 6.3999C12.442 6.3999 12.8004 6.7575 12.8004 7.1999V11.1999H16.8004C17.242 11.1999 17.6004 11.5575 17.6004 11.9999C17.6004 12.4423 17.242 12.7999 16.8004 12.7999Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }